import { render, staticRenderFns } from "./ApprovalDetailsDrawer.vue?vue&type=template&id=760da578"
import script from "./ApprovalDetailsDrawer.vue?vue&type=script&lang=js"
export * from "./ApprovalDetailsDrawer.vue?vue&type=script&lang=js"
import style0 from "./ApprovalDetailsDrawer.vue?vue&type=style&index=0&id=760da578&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports